import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "../../../hooks/useTranslation";
import EmptyContent from "../../../components/General/EmptyContent";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import { useSelector } from "react-redux";
import { selectSiteLang } from "../../../store/userSlice";
import SingleShowroomCard from "../SingleShowroomCard";
import "swiper/swiper.min.css";
import "../../HomeSlider/pagination.css";
import style from "./index.module.css";
import * as ReactDOMServer from "react-dom/server";
import { vehicleModules } from "../../../utils/GeneralTypes";

SwiperCore.use([Autoplay, Pagination]);

const ShowroomCardsSlider = ({ showrooms }: ComponentPropsType) => {
  const siteLang = useSelector(selectSiteLang);
  const { locale } = useTranslation();

  return (
    <Swiper
      className={`${style.main_slider} showrooms_slider vehicles_slider`}
      dir={siteLang === "ar" ? "rtl" : "ltr"}
      pagination={{
        clickable: true,
        renderBullet: (index, className) => {
          return ReactDOMServer.renderToStaticMarkup(
            <span className={className}>
              {vehicleModules.map((module, moduleIndex) =>
                index === moduleIndex ? <module.Icon key={moduleIndex} color="black" height="35" width="35" /> : null,
              )}
            </span>,
          );
        },
      }}
      autoplay={{
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      }}
    >
      {showrooms.map((section, index) =>
        section.length > 0 ? (
          <SwiperSlide key={index} className={style.slide}>
            <div className="row">
              {section.map((showroom, index) => (
                <div key={index} className="col-md-4">
                  <SingleShowroomCard
                    name={showroom.name}
                    image={showroom.image}
                    location={showroom.info}
                    link={showroom.link}
                    types={showroom.types}
                  />
                </div>
              ))}
            </div>
          </SwiperSlide>
        ) : (
          <SwiperSlide key={index} className={style.slide}>
            <div className="col-12">
              <EmptyContent>
                <p>{locale("noResult")}</p>
              </EmptyContent>
            </div>
          </SwiperSlide>
        ),
      )}
    </Swiper>
  );
};

export default ShowroomCardsSlider;

type ComponentPropsType = {
  showrooms: {
    name: string;
    // TODO: this field is nullable in the database change its type
    image: string;
    info: string;
    link: string;
    types?: string;
  }[][];
};
